import { render, staticRenderFns } from "./WorkflowSkipTask.vue?vue&type=template&id=040d4955&"
import script from "./WorkflowSkipTask.vue?vue&type=script&lang=js&"
export * from "./WorkflowSkipTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports